import { FC, memo } from 'react';

import { MuiModalStyled } from './styled';
import { IModalProps as IProps } from './types';

export const ModalComponent: FC<IProps> = memo(({ open, onClose, children, fullScreen, ...props }) => {
  return (
    <MuiModalStyled ownerState={{ fullScreen }} open={open} onClose={onClose} {...props}>
      {children}
    </MuiModalStyled>
  );
});
